import React,{useState,useEffect} from 'react';
import {motion,AnimatePresence} from 'framer-motion';

const FloatingCTA=()=> {
  const [isVisible,setIsVisible]=useState(false);

  useEffect(()=> {
    const handleScroll=()=> {
      const scrolled=window.scrollY;
      const windowHeight=window.innerHeight;
      // Show after scrolling past the hero section
      setIsVisible(scrolled > windowHeight * 0.5);
    };
    window.addEventListener('scroll',handleScroll);
    return ()=> window.removeEventListener('scroll',handleScroll);
  },[]);

  const navigateToCourse=()=> {
    window.open('https://swiy.co/hYor','_blank','noopener,noreferrer');
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{y: 100,opacity: 0}}
          animate={{y: 0,opacity: 1}}
          exit={{y: 100,opacity: 0}}
          transition={{duration: 0.3}}
          className="fixed bottom-4 left-4 right-4 z-50 md:hidden"
        >
          <button
            onClick={navigateToCourse}
            className="w-full bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white py-6 rounded-xl font-bold shadow-xl transition-all duration-200 border-4 border-amber-300"
          >
            Start Learning AI - <span className="relative inline-block">
              <span className="text-red-600 line-through decoration-red-600 decoration-4 text-lg">$250</span>
              <span className="ml-2 font-black bg-gradient-to-r from-green-400 to-emerald-500 bg-clip-text text-transparent text-2xl" style={{fontWeight: 900}}>$65</span>
            </span>
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingCTA;